import React from 'react'
import '../Styles/ActionButton.scss'

const ActionButton = ({ variant = 'primary', loading, disabled, icon, children, className = '', ...rest }) => {
  const classes = [
    'action-btn',
    `action-btn--${variant}`,
    loading ? 'action-btn--loading' : '',
    className
  ].filter(Boolean).join(' ')

  return (
    <button className={classes} disabled={disabled || loading} {...rest}>
      {loading ? (
        <>
          <span className="action-btn-spinner" />
          <span>Saving...</span>
        </>
      ) : (
        <>
          {icon && <span className="action-btn-icon">{icon}</span>}
          <span>{children}</span>
        </>
      )}
    </button>
  )
}

export default ActionButton
